import * as Sentry from '@sentry/react'
import { User } from '@/store/user.ts'

export default function setSentryUser(user: User) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name as string,
    surname: user.surname as string,
  })


}
